export const CONFIG_PAGES = [
  { id: 1, pagina: 'home' },
  { id: 2, pagina: 'relatorio' },
  { id: 2435, pagina: 'preco-combustivel' },
  { id: 2437, pagina: 'subfrota' },
  { id: 2448, pagina: 'subfrota/relatorio-abastecimentos-editaveis' },
  { id: 2449, pagina: 'subfrota/relatorio-abastecimentos-editados' },
  { id: 2259, pagina: 'preco-combustivel' },
  { id: 2451, pagina: 'configuracao-nfe' },
  { id: 2455, pagina: 'perfis' },
  { id: 2457, pagina: 'venda-arla' },
  { id: 'upload-csv', pagina: 'upload-csv' }, // upload-csv pagina sem id
  { id: 2461, pagina: 'registro-transacoes' },
  { id: 2464, pagina: 'aprovar-acordos' },
  { id: 2467, pagina: 'central-bloqueios' },
  { id: 9999, pagina: 'relatorios' },
  { id: 1692, pagina: 'bloqueio-horario' },
  { id: 2464, pagina: 'central-de-acordos/17' },
  { id: 2465, pagina: 'central-de-acordos' },
];

export const CONFIG_URLS_API = {
  API_AceiteDeContrato:
    'api/PrecoCombustivel/consulta-aceite-contrato-preco-combustivel-json-async',
  API_ConsultaDePreco:
    'api/PrecoCombustivel/consulta-preco-combustivel-json-async/',
  API_ConsultaAcessoTelaPrecosNova:
    'api/posto/posto-sem-acesso-central-precos-async',
  API_CadastroDePreco:
    'api/PrecoCombustivel/atualizar-preco-combustivel-json-async',
  API_ManterPrecos: 'api/PrecoCombustivel/manter-precos-combustivel-json-async',
  API_Pegar_Qtddias_CombustivelAtrasado:
    'api/PrecoCombustivel/pegar-qtddias-combustivelAtrasado-async',
  API_NecessitaAtualizacaoPrecos:
    'api/PrecoCombustivel/atualizacao-precos-async',
  API_ConsultaListaCombustiveis: 'api/ConsultaCombustiveis/Listar/',
  API_ConsultaSubFrota: 'api/subfrota/Consultar',
  API_ListaSubFrota: 'api/subfrota/Listar',
  API_ListaVeiculosSubFrota: 'api/subfrota/ListarVeiculo',
  API_ObterSubFrota: 'api/subfrota/Obter',
  API_IncluirSubFrota: 'api/subfrota/Incluir',
  API_AlterarSubFrota: 'api/subfrota/Alterar',
  API_ExcluirSubFrota: 'api/subfrota/Excluir',
  API_ListaRelatorioExtratoCartaoAbastecimento:
    'api/subfrota/listaRelatorioExtratoCartaoAbastecimento',
  API_ListaContatoFrota: 'api/frota/ListarContato',
  API_ListaFrota: 'api/frota/Listar',
  API_BuscaFrota: 'api/frota/Buscar',
  API_ListaVeiculo: 'api/veiculo/Listar',
  API_BuscaVeiculo: 'api/veiculo/Buscar',
  API_ListaMotorista: 'api/Motorista/Listar',
  API_BuscaMotorista: 'api/Motorista/Buscar',
  API_ConsultaCEP: 'api/BuscaCep/consulta',
  API_ConsultaMunicipios: 'api/Corporativo/Municipios',
  URL_CadastroVeiculos: '/portal/login/index?cmdName=2284&userGuid=',
  API_PostoAutorizadoUploadCsv:
    'api/PrecoCombustivel/verificar-permissao-upload-csv-async',

  /* Inicio api abastecimentos frota */
  API_ListarAbastecimentosEditaveis:
    'api/subfrota/listar-abastecimentos-editaveis',
  API_SalvarAbastecimentoEditado: 'api/subfrota/salvar-abastecimento-editado',
  API_ListarAbastecimentosEditados:
    'api/subfrota/listar-abastecimentos-editados',
  API_SalvarAbastecimentoEditadoAprovado:
    'api/subfrota/salvar-abastecimento-editado-aprovado',
  API_ListaContatos: 'api/contatos',

  API_BuscaSubfrota: 'api/VeiculosBloqueio/BuscarSubFrota',
  /* Fim api abastecimentos frota */

  /* Inicio api configuração NotaFiscal */
  API_ConsultaArquivei: 'api/NotaFiscal/arquivei/consultar',
  API_CancelarArquivei: 'api/NotaFiscal/arquivei/cancelar',
  API_ConsultaParametroReagendamento:
    'api/NotaFiscal/parametroReagendamento/consultar',
  API_AlterarParametroReagendamento:
    'api/NotaFiscal/parametroReagendamento/alterar',
  API_ConsultaParametroConciliacao:
    'api/NotaFiscal/parametroConciliacao/consultar',
  API_AlterarParametroConciliacao:
    'api/NotaFiscal/parametroConciliacao/alterar',
  /* Fim api configuração de NotaFiscal */

  /* Inicio api configuração de Perfis */
  API_PegarListaPerfisAsync: 'api/perfis/GetListaPerfisAsync',
  API_GetListUsuariosPorPerfilAsync: 'api/perfis/GetListUsuariosPorPerfilAsync',
  API_CriarPerfilAsync: 'api/perfis/CriarPerfilAsync',
  API_GetListPermissaoAsync: 'api/perfis/GetListPermissaoAsync',
  API_AlterarPerfilAsync: 'api/perfis/AlterarPerfilAsync',
  API_DesativarPerfilAsync: 'api/perfis/DesativarPerfilAsync',
  API_GetPermissoesTemplate: 'api/perfis/GetTemplatePortal',
  /* Fim api configuração de Perfis */

  /* Inicio api configuração de Usuarios */
  API_CriarUsuarioAsync: 'api/usuarios/CriarUsuarioAsync',
  API_GetListaUsuariosAsync: 'api/usuarios/GetListaUsuariosAsync',
  API_AtivarDesativarUsuarioAsync: 'api/usuarios/AtivarDesativarUsuarioAsync',
  /* Fim api configuração de Usuarios */

  /* Venda de arla*/
  API_PegarListaPostosAsync: 'api/posto/pegar-todos',
  API_LiberarBloquearVendaArlaNoPosto: 'api/posto/bloquear-liberar-postos',
  API_BsucarCsvPrecosPosto: 'api/posto/buscar-csv',
  API_UploadCsvPrecosPosto: 'api/posto/atualizar-precos-csv',
  /* Fim venda arla*/

  /* INICIO REGISTRO OPERACOES */
  API_ListaRegistroOperacoes: 'api/RegistroOperacoes/Listar',
  API_ObterImagemTransacao: 'api/RegistroOperacoes/ObterImagemTransacao',
  /* INICIO REGISTRO OPERACOES */

  /* INICIO API DE CONSULTA DE HORARIOS */
  API_ConsultaHorarios: 'api/OnlineBloqueio/horario',
  /* FIM API DE CONSULTA DE HORARIOS */

  /* INICIO CENTRAL DE BLOQUEIOS */
  API_ListaCentralBloqueios: 'api/CentralBloqueio/Dashboard',
  /* INICIO CENTRAL DE BLOQUEIOS */

  /* INICIO ACORDOS */
  API_GetAcordosPendentesAsync: 'api/acordo/postAcordosPendentesAsync',
  API_GetAcordoStatus: 'api/acordo/status',
  API_CriarNovoAcordo: 'api/acordo/criarNovoAcordoAsync',
  API_AprovarOuRejeitarAcordosAsync: 'api/acordo/aprovarOuRejeitarAcordosAsync',
  API_CancelarAcordosAsync: 'api/acordo/cancelarAcordosAsync',
  /* FIM ACORDOS */
};
